<div class="employee-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">Please log in first.</div>

  <section *ngIf="isAuthenticated" class="list-content">
    <div class="list-toolbar">
      <div class="message info" *ngIf="isLoading">{{ status }}</div>
      <div class="message subtle" *ngIf="!isLoading && !error">Limit: {{ activeEmployeeCount }}/{{ employeeCreateLimit }}</div>
    </div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="employees"
      [deletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No subusers found.'"
      [menuActions]="employeeMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedEmployee" (click)="closeDetailsModal()">
    <div class="details-modal employee-details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">&times;</button>
      <h3>Subuser Information</h3>

      <div class="employee-profile-card">
        <span class="employee-profile-avatar-wrap" *ngIf="firstEmployeeImageAttachment() as employeeImage; else noEmployeeImage">
          <img *ngIf="employeeProfileImageUrl; else employeeProfileFallback" [src]="employeeProfileImageUrl" alt="Subuser profile image" class="employee-profile-avatar" />
          <button
            type="button"
            class="employee-avatar-eye-btn"
            aria-label="View image"
            (click)="openAttachmentPreview(employeeImage); $event.stopPropagation()"
          >
            <span class="employee-avatar-eye-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M12 5C6.5 5 2 12 2 12s4.5 7 10 7 10-7 10-7-4.5-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"></path>
                <circle cx="12" cy="12" r="2.2"></circle>
              </svg>
            </span>
          </button>
        </span>
        <ng-template #noEmployeeImage>
          <span class="employee-profile-avatar-wrap">
            <span class="employee-profile-avatar-fallback">{{ employeeInitials() }}</span>
          </span>
        </ng-template>
        <ng-template #employeeProfileFallback>
          <span class="employee-profile-avatar-fallback">{{ employeeInitials() }}</span>
        </ng-template>

        <div class="employee-profile-meta">
          <div class="employee-profile-name">{{ selectedEmployee.name || 'N/A' }}</div>
          <div class="employee-profile-sub">{{ selectedEmployee.mobileNumber || 'N/A' }}</div>
          <div class="employee-profile-sub">{{ selectedEmployee.email || 'N/A' }}</div>
        </div>
      </div>

      <div class="details-grid">
        <div class="details-item details-item-full">
          <span class="label">Username</span>
          <div class="details-value-actions">
            <span class="value username-value">{{ isEmployeeUsernameVisible ? employeeUsernameValue() : maskedEmployeeUsername() }}</span>
            <div class="details-inline-actions">
              <button
                type="button"
                class="details-mini-btn"
                (click)="toggleEmployeeUsernameVisibility()"
                [disabled]="employeeUsernameValue() === 'N/A'"
              >
                {{ isEmployeeUsernameVisible ? 'Hide' : 'Show' }}
              </button>
              <button
                type="button"
                class="details-mini-btn details-copy-btn"
                (click)="copyEmployeeUsername()"
                [disabled]="employeeUsernameValue() === 'N/A'"
              >
                {{ employeeUsernameCopied ? 'Copied' : 'Copy' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="details-actions">
        <button type="button" class="PositiveBTN" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <app-add-edit-employee
    *ngIf="isEditOpen && selectedEmployee"
    [mode]="'edit'"
    [initialEmployee]="selectedEmployee"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
    (editImage)="openEditImageModal()"
  ></app-add-edit-employee>

  <div class="modal-overlay upload-overlay" *ngIf="isUploadModalOpen" (click)="skipUploadModal()">
    <div class="details-modal upload-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="skipUploadModal()">&times;</button>
      <h3>{{ uploadMode === 'edit' ? ('user.uploadModalEditTitle' | t:'Edit Subuser Image') : ('user.uploadModalCreateTitle' | t:'Upload Subuser Image') }}</h3>
      <p class="upload-hint">{{ 'user.uploadHint' | t:'Optional: You can skip this step and upload later.' }}</p>
      <p class="upload-hint subtle">{{ 'common.allowed' | t:'Allowed' }}: {{ employeeImageAllowedExtensionsText }} | {{ 'topHeader.max' | t:'Max' }}: {{ employeeImageMaxFileCount }} {{ employeeImageMaxFileCount === 1 ? ('common.file' | t:'File') : ('common.files' | t:'Files') }}</p>

      <div class="upload-existing" *ngIf="uploadExistingAttachments.length > 0">
        <div class="upload-count">{{ 'user.existingFile' | t:'Existing file' }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadExistingAttachments; let i = index">
            <button type="button" class="existing-file-link" (click)="openAttachmentPreview(file)">
              {{ file.attachmentFileName || ('Document #' + file.id) }}
            </button>
            <button type="button" class="remove-file" (click)="removeExistingAttachment(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>

      <label class="upload-picker">
        <input type="file" accept=".jpg,.jpeg,.png" (change)="onUploadFilesSelected($event)" />
        <span>{{ 'common.selectFile' | t:'Select File' }}</span>
      </label>

      <div class="upload-selected" *ngIf="uploadFiles.length > 0; else noUploadFile">
        <div class="upload-count">{{ uploadFiles.length }} {{ uploadFiles.length === 1 ? ('renter.fileSelectedSingular' | t:'file selected') : ('renter.fileSelectedPlural' | t:'files selected') }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadFiles; let i = index">
            <span class="name">{{ file.name }}</span>
            <button type="button" class="remove-file" (click)="removeUploadFile(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>
      <ng-template #noUploadFile>
        <div class="upload-empty">{{ 'user.noFileSelected' | t:'No file selected.' }}</div>
      </ng-template>

      <div class="message error" *ngIf="uploadError">{{ uploadError }}</div>
      <div class="details-actions upload-actions">
        <button type="button" class="SecondaryBTN" (click)="skipUploadModal()">{{ 'common.skip' | t:'Skip' }}</button>
        <button type="button" class="PositiveBTN" (click)="uploadEmployeeImage()" [disabled]="isUploadingAttachment">
          {{ isUploadingAttachment ? ('common.saving' | t:'Saving...') : (uploadMode === 'edit' ? ('user.saveImage' | t:'Save Image') : ('common.uploadingAction' | t:'Upload')) }}
        </button>
      </div>
    </div>
  </div>

  <app-image-crop-modal
    [visible]="!!uploadCropSourceFile"
    [sourceFile]="uploadCropSourceFile"
    [title]="'user.cropSubuserImageTitle' | t:'Crop Subuser Image'"
    [hint]="'user.cropSubuserImageHint' | t:'Drag the image and adjust zoom to fit the profile area. The cropped image will be compressed before upload.'"
    [outputHint]="'user.cropSubuserImageOutputHint' | t:'The cropped image will be saved as JPG to reduce upload size.'"
    [confirmLabel]="'common.useCroppedImage' | t:'Use Cropped Image'"
    [cancelLabel]="'common.cancel' | t:'Cancel'"
    fallbackBaseName="subuser-image"
    (cancel)="onEmployeeImageCropCancelled()"
    (confirm)="onEmployeeImageCropped($event)"
  ></app-image-crop-modal>

  <div class="modal-overlay preview-overlay" *ngIf="isImagePreviewOpen" (click)="closeImagePreview()">
    <div class="details-modal image-preview-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeImagePreview()">&times;</button>
      <h3>{{ imagePreviewName || ('common.preview' | t:'Preview') }}</h3>
      <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl" [alt]="imagePreviewName || 'Attachment preview'" class="preview-image" />
    </div>
  </div>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteEmployee"
    [title]="'user.deleteTitle' | t:'Delete Subuser'"
    [message]="'user.deleteMessage' | t:'Delete this subuser?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteEmployee()"
  ></app-confirm-action-modal>

  <app-confirm-action-modal
    [visible]="pendingDeleteOnlyUpload"
    [title]="'action.delete' | t:'Delete'"
    [message]="'user.deleteExistingImageConfirm' | t:'Do you want to delete this existing server image without uploading a new one?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [danger]="true"
    (cancel)="closeDeleteOnlyUploadModal()"
    (confirm)="confirmDeleteOnlyUpload()"
  ></app-confirm-action-modal>
</div>
